var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", staticStyle: { overflow: "hidden" } },
    [
      _c(
        "div",
        { staticClass: "information" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("基本信息")
            ])
          ]),
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _vm.childData.isPerson !== "0"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "客户名称" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.customerName))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "客户类型" } }, [
                            _c("span", [_vm._v("个人")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "所属小区名称" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.areaName))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "性别" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.childData.sexName))])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "出生日期" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userBirthday))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "籍贯" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userNative))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "证件类型" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userCardTypeName))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-form-item", { attrs: { label: "证件号码" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userCardSerno))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _vm._v("联系方式")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话1" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneOne))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话2" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneTwo))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话3" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneThree))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "QQ" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.childData.userQq))])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-form-item", { attrs: { label: "微信号" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userWebchartNum))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "电子邮箱" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userEmail))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "户籍地址" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userPermanentAddr))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "现住地址" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userCurrentAddr))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "备注信息" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userRemark))
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "客户名称" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.customerName))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "客户类型" } }, [
                            _c("span", [_vm._v("单位")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "所属小区名称" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.areaGroupName))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "公司性质" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.childData.sexName))])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "公司人数" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.childData.userSex))])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "公司开户名称" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userNative))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "银行账号" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userEmail))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "社会信用代码" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userCardSerno))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "执照有效期" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userBirthday))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "法人代表" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userNativeProvince))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _vm._v("联系方式")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "联系电话" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userPhoneOne))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话1" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneOne))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话2" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneTwo))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话3" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.userPhoneThree))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-form-item", { attrs: { label: "单位传真" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.childData.phoneFax))])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "备注信息" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.userRemark))
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }